import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Products = () => {
  return (
    <div className="font-inter" data-testid="products-page">
      {/* Header */}
      <section className="bg-[#2B2B2B] text-white py-16" data-testid="products-header">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-poppins font-bold text-4xl md:text-5xl mb-4">
            Our Products
          </h1>
          <p className="text-xl text-gray-300">
            High-quality wooden pallets and industrial packaging solutions
          </p>
          <div className="w-24 h-1 bg-[#B11217] mt-4"></div>
        </div>
      </section>

      {/* Product Categories */}
      <section className="py-16 bg-white" data-testid="product-categories">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Wooden Pallets */}
            <Link
              to="/products/wooden-pallets"
              className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300"
              data-testid="product-wooden-pallets-card"
            >
              <div
                className="h-96 bg-cover bg-center"
                style={{
                  backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(https://images.pexels.com/photos/9498584/pexels-photo-9498584.jpeg)'
                }}
              >
                <div className="absolute inset-0 flex flex-col justify-end p-8 text-white">
                  <h2 className="font-poppins font-bold text-3xl mb-3 group-hover:text-[#B11217] transition-colors">
                    Wooden Pallets
                  </h2>
                  <p className="text-lg mb-4 text-gray-200">
                    Pine Wood, Hardwood, Jungle Wood pallets in various sizes and load capacities. ISPM-15 certified for export.
                  </p>
                  <span className="inline-flex items-center font-semibold text-white group-hover:text-[#B11217] group-hover:gap-2 transition-all">
                    View Details <ArrowRight size={20} className="ml-1" />
                  </span>
                </div>
              </div>
            </Link>

            {/* Industrial Packaging */}
            <Link
              to="/products/industrial-packaging"
              className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300"
              data-testid="product-industrial-packaging-card"
            >
              <div
                className="h-96 bg-cover bg-center"
                style={{
                  backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(https://images.pexels.com/photos/27111449/pexels-photo-27111449.jpeg)'
                }}
              >
                <div className="absolute inset-0 flex flex-col justify-end p-8 text-white">
                  <h2 className="font-poppins font-bold text-3xl mb-3 group-hover:text-[#B11217] transition-colors">
                    Industrial Packaging
                  </h2>
                  <p className="text-lg mb-4 text-gray-200">
                    Comprehensive range of wooden boxes, crates, plywood packaging, and corrugated solutions for safe transport.
                  </p>
                  <span className="inline-flex items-center font-semibold text-white group-hover:text-[#B11217] group-hover:gap-2 transition-all">
                    View Details <ArrowRight size={20} className="ml-1" />
                  </span>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Our Products */}
      <section className="py-16 bg-[#F2F2F2]" data-testid="why-choose-products">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-poppins font-bold text-3xl text-[#2B2B2B] mb-8 text-center">
            Why Choose Our Products
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 border-l-4 border-[#B11217]">
              <h3 className="font-poppins font-semibold text-xl text-[#2B2B2B] mb-3">Export Ready</h3>
              <p className="text-gray-600">
                All products are ISPM-15 certified and comply with international standards for export shipping.
              </p>
            </div>
            <div className="bg-white p-6 border-l-4 border-[#B11217]">
              <h3 className="font-poppins font-semibold text-xl text-[#2B2B2B] mb-3">Durable & Strong</h3>
              <p className="text-gray-600">
                Premium quality wood ensures maximum load-bearing capacity and long-lasting durability.
              </p>
            </div>
            <div className="bg-white p-6 border-l-4 border-[#B11217]">
              <h3 className="font-poppins font-semibold text-xl text-[#2B2B2B] mb-3">Custom Solutions</h3>
              <p className="text-gray-600">
                Tailored dimensions and specifications to meet your unique business requirements.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;